﻿<template>
    <aside class="cart-summary cart-side">
        <div class="basket-summary cart-summary-card">

            <itinerary_breakdown></itinerary_breakdown>
            <hr />
            <trip_summary :show_total="false"></trip_summary>

            <fieldset class="summary-options section sm-options" :hidden="No_Deposit()" id="payment_checkout">
                <legend class="sm-options-title">Payment options</legend>
                <label v-if="show_full_payment()" class="sm-option" :class="{ 'is-checked': full_payment }">
                    <input type="radio" name="payment_option" :checked="full_payment" @change="full_payment_selected()">
                    <span class="sm-option-text">
                        <strong>Pay in full</strong>
                        <small>{{get_total_outstanding_Formatted()}} today</small>
                    </span>
                </label>
                <label v-if="show_deposit_payment()" class="sm-option" :class="{ 'is-checked': deposit }">
                    <input type="radio" name="payment_option" :checked="deposit" @change="deposit_selected()">
                    <span class="sm-option-text">
                        <strong>Pay a deposit</strong>
                        <small>{{get_Total_Deposit_Formatted()}} today, balance later</small>
                    </span>
                </label>
            </fieldset>

            <div class="summary-total section sm-grand">
                <span class="sm-grand-label">{{ full_payment ? 'Total to pay' : 'Deposit to pay' }}</span>
                <p id="totalPrice" class="sm-grand-amount">
                    {{get_Total_Selected_Formatted()}} <small>{{get_Currency()}}</small>
                </p>
                <span class="sm-grand-note">Includes all taxes.</span>
                <p class="sm-grand-balance" :hidden="full_payment">Balance of <strong>{{get_Balance()}} {{get_Currency()}}</strong> due later</p>
            </div>

            <div v-if="!isAgent_Login()" class="cart-agree">
                <p>By booking with us you agree to our <a :href=terms_policy() target="_blank" rel="noopener">terms and conditions</a>.</p>
                <label class="pp-check">
                    <input v-model="agreeCheckbox" type="checkbox" class="focus:ring-action text-action border-grey-light rounded">
                    I have read and agree with the terms and conditions
                </label>
            </div>

            <div class="summary-action sm-actions">
                <div v-if="displayCompleteRequired" class="sm-alert" role="alert">
                    <span aria-hidden="true">!</span>
                    Please complete all required passenger details to continue
                </div>
                <div v-if="saveFailed" class="sm-alert" role="alert">
                    <span aria-hidden="true">!</span>
                    We couldn't save the passenger details. Please check your connection and try again.
                </div>

                <button v-if="agreeCheckbox" type="button" class="button button-pink-book full cart-cta" :disabled="isloading" @click="check_out()">
                    <svg v-if="isloading" class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
                    {{ isloading ? 'Saving details...' : checkout }}
                </button>
                <button v-else type="button" class="button full cart-cta is-disabled" disabled>
                    Agree to terms to continue
                </button>

                <small class="cart-contact">{{get_Contact_Text()}}</small>
            </div>

            <div id="payment-gateway-component"></div>
        </div>
    </aside>
</template>

<script lang="ts" src="./summary.ts"></script>